<div class="timer-container">
  <div style="line-height: 15px; font-size: 15px; margin-left: 8px">
    Rule execution info
  </div>
  <button
    (mouseover)="isOpen = true"
    (mouseout)="isOpen = false"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    mat-icon-button
    aria-label="next rule execution">
    <mat-icon class="material-symbols-outlined">{{
      !error ? 'update' : 'warning'
    }}</mat-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen">
    @if (!error && (timeLeft$ | async); as t) {
      <div class="timer" [ngClass]="calculateClasses()">
        <div>
          <span id="hours"> {{ t.hoursToExecution }} </span>hrs
          <span id="minutes"> {{ t.minutesToExecution }} </span>min
          <span id="seconds"> {{ t.secondsToExecution }} </span>s<br />
        </div>
        <div>until next rules deployed</div>
      </div>
    } @else {
      <div class="timer">{{ error }}</div>
    }
  </ng-template>

  <button
    [disabled]="!!error"
    (mouseover)="isInfoOpen = true"
    (mouseout)="isInfoOpen = false"
    cdkOverlayOrigin
    #infoTrigger="cdkOverlayOrigin"
    mat-icon-button
    aria-label="next rule execution">
    <mat-icon class="material-symbols-outlined">info</mat-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="infoTrigger"
    [cdkConnectedOverlayOpen]="isInfoOpen">
    @if (timeLeft$ | async; as t) {
      <div class="info" [ngClass]="calculateClasses()">
        Rules scheduled to be deployed today at
        @for (
          date of datesArray;
          track date;
          let isLast = $last;
          let i = $index
        ) {
          {{ date | date: 'HH:mm' }}{{ isLast ? '' : ', ' }}
        }
      </div>
    }
  </ng-template>
</div>
